import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

export const getCompletionReports = createAsyncThunk(
  'report/getCompletionReports',
  async (
    { courses, managers, functionCodes, countryCodes, organizations },
    { rejectWithValue }
  ) => {
    try {
      // Use URLSearchParams for proper encoding of parameter values
      const searchParams = new URLSearchParams();

      // Add course IDs
      courses.forEach((course) => {
        searchParams.append('CourseIds', course.value);
      });

      // Add function codes
      functionCodes.forEach((functionCode) => {
        searchParams.append('FunctionCodes', functionCode.value);
      });

      // Add manager IDs
      managers.forEach((manager) => {
        searchParams.append('ManagerIds', manager.value);
      });

      // Add country codes
      countryCodes.forEach((countryCode) => {
        searchParams.append('CountryCodes', countryCode.value);
      });

      // Add organizations (properly encoded, including & characters)
      organizations.forEach((organization) => {
        searchParams.append('Organizations', organization.value);
      });

      const queryString = searchParams.toString();
      const url = `/admin/reports${queryString ? `?${queryString}` : ''}`;

      const response = await axios.get(url);
      return response.data;
    } catch (error) {
      return rejectWithValue({
        status: error.response.status,
        data: error.response.data,
      });
    }
  }
);

export default getCompletionReports;
